(ns app.front.ui.modal
  (:require [core.front.carbon :as cc]))

(defn composed-input-modal
  "Modal with closing on click outside of modal prevented by default to avoid frustration when inputting data."
  [opts & children]
  (apply cc/composed-modal
         (assoc opts :prevent-close-on-click-outside true)
         children))
